import moment from 'moment';

import type { UsStateConfig } from '@dnc/baseline/contentful/types';
import { type State } from '@dnc/baseline/data/jurisdictions';

import { Services } from '../services/services';
import { UrlHelper } from '../services/url-helper';

/**
 * Helper for loading a {@link UsStateConfig} from Contentful. Uses the URL
 * to determine if we’re doing a test config or preview data.
 *
 * Throws if the loading failed.
 */
export async function fetchUsStateConfig(
  services: Pick<Services, 'voterEducation'>,
  urlHelper: UrlHelper,
  jurisdiction: State,
  now = moment()
): Promise<UsStateConfig> {
  const contentfulParams = urlHelper.parseContentfulParams();

  const jurisdictionConfig = await services.voterEducation.fetchUsStateConfig(
    jurisdiction,
    !!contentfulParams.preview,
    !!contentfulParams.test_config,
    now
  );

  if (!jurisdictionConfig) {
    throw new Error(`Failure loading jurisdiction: ${jurisdiction}`);
  }

  return jurisdictionConfig;
}
